// Toggle Compare — sliding thumb measures each button's real width/position (unequal-width labels need this, can't be done in pure CSS).
import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('[data-p360-toggle]').each(function () {
		var $switch = $(this);
		var $thumb = $switch.find('.p360-tgl__thumb');
		var $btns = $switch.find('.p360-tgl__opt');
		var $section = $switch.closest('.p360-tgl');
		var $listA = $section.find('[data-p360-list="a"]');
		var $listB = $section.find('[data-p360-list="b"]');

		function place($active) {
			if (!$active.length) {
				return;
			}
			$thumb.css({
				width: $active[0].offsetWidth + 'px',
				transform: 'translateX(' + ($active[0].offsetLeft - 5) + 'px)',
			});
		}

		function setMode(mode) {
			$btns.each(function () {
				$(this).toggleClass('is-active', $(this).data('mode') === mode);
			});
			$switch.toggleClass('show-a', mode === 'a');

			var $active = $switch.find('.p360-tgl__opt.is-active');
			requestAnimationFrame(function () {
				place($active);
			});

			if (mode === 'a') {
				$listB.attr('hidden', true);
				$listA.removeAttr('hidden');
			} else {
				$listA.attr('hidden', true);
				$listB.removeAttr('hidden');
			}
		}

		$btns.on('click', function () {
			setMode($(this).data('mode'));
		});

		setMode('b');

		$(window).on('load', function () {
			place($switch.find('.p360-tgl__opt.is-active'));
		});
		$(window).on('resize', function () {
			place($switch.find('.p360-tgl__opt.is-active'));
		});
	});
});